import type { FormattedBlogPost } from "../../../../libs/prismic/types"
import { useUrl } from "../../../../libs/router"
import { Product } from "../../../../types"
import { Layout as LuggageStorageLayout } from "@/components/LuggageStorage/Layout/Layout"
import { Layout as PackageAcceptanceLayout } from "@/components/Packages/Layout/Layout"

export type LayoutProps = { article: FormattedBlogPost; languages: string[]; children: React.ReactNode }

export const Layout = ({ article, languages, children }: LayoutProps) => {
  const { absolutePath } = useUrl()
  const Layout = article.product === Product.PackageAcceptance ? PackageAcceptanceLayout : LuggageStorageLayout

  return (
    <Layout
      languages={languages}
      headProps={{
        title: article.metaTitle,
        description: article.metaDescription,
        url: absolutePath,
        image: article.image?.url,
        noIndex: article.noIndex,
      }}
      hideNewsletterBanner>
      {children}
    </Layout>
  )
}
